/** * * Asynchronously loads the component for
SupportCenter
* */ import { lazyLoad } from "utils/loadable";
export const SupportCenter = lazyLoad(
  () => import("./index"),
  (module) => module.SupportCenter
);
